/* Slide-in "Reviews over Kameo": laadt alle reviews pas bij openen, 50 per keer, filter op sterren. */
(function () {
  var sec = document.querySelector('[data-krm]');
  if (!sec || sec.dataset.krmKlaar) return;
  sec.dataset.krmKlaar = '1';

  var PER = 50;
  var dr = sec.querySelector('.krm-dr');
  var ov = sec.querySelector('.krm-ov');
  var lijst = dr.querySelector('.krm-lijst');
  var meer = dr.querySelector('.krm-meer');
  var filterRegel = dr.querySelector('.krm-filter');
  var data = null, laden = null, filter = 0, getoond = 0, vorigeFocus = null;
  var MAAND = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
  var STER_LIJN = 'm16.399 14.574 4.413-4.283-6.086-.894L12 3.887l-2.726 5.51-6.086.894L7.6 14.574l-1.053 6.072L12 17.776l5.438 2.87-1.039-6.072ZM24 9.425c0 .212-.125.443-.375.693l-5.236 5.105 1.24 7.212c.01.067.015.164.015.289 0 .48-.197.72-.591.72-.183 0-.375-.057-.577-.172L12 19.867l-6.476 3.404c-.212.115-.404.173-.577.173-.202 0-.353-.07-.454-.21a.85.85 0 0 1-.152-.511c0-.058.01-.154.03-.289l1.24-7.211-5.25-5.106C.12 9.858 0 9.628 0 9.425c0-.355.27-.577.808-.663l7.24-1.053 3.245-6.562c.183-.395.418-.592.707-.592s.524.197.707.592l3.245 6.562 7.24 1.053c.539.086.808.308.808.663Z';
  var STER_VUL = 'M24 9.425c0 .212-.125.443-.375.693l-5.236 5.105 1.24 7.212c.01.067.015.164.015.289a.85.85 0 0 1-.151.511.51.51 0 0 1-.44.21c-.183 0-.375-.058-.577-.174L12 19.869l-6.476 3.404c-.212.115-.404.173-.577.173-.202 0-.353-.07-.454-.21a.85.85 0 0 1-.152-.511c0-.058.01-.154.03-.289l1.24-7.211-5.25-5.106C.12 9.858 0 9.628 0 9.425c0-.355.27-.577.808-.663l7.24-1.053 3.245-6.562c.183-.395.418-.592.707-.592s.524.197.707.592l3.245 6.562 7.24 1.053c.539.086.808.308.808.663Z';

  function esc(t) {
    return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function sterren(n) {
    var h = '';
    for (var i = 1; i <= 5; i++) {
      var v = i <= n ? 'vol' : 'leeg';
      h += '<svg class="loox-icon krm-ster krm-ster--' + v + '" viewBox="0 0 24 24" aria-hidden="true"><path class="krm-ster__lijn" d="' + STER_LIJN + '"/><path class="krm-ster__vul" d="' + STER_VUL + '"/></svg>';
    }
    return '<span class="loox-rating krm-sterren" role="img" aria-label="' + n + ' van 5 sterren"><span class="loox-rating-content">' + h + '</span></span>';
  }
  function datum(d) {
    var p = d.split('-');
    return (+p[2]) + ' ' + MAAND[+p[1] - 1] + ' ' + p[0];
  }
  function kaart(r) {
    return '<article class="krm-kaart"><div class="krm-kaart__top">' + sterren(r.s) +
      '<span class="krm-kaart__d">' + datum(r.d) + '</span></div>' +
      (r.k ? '<p class="krm-kaart__k">' + esc(r.k) + '</p>' : '') +
      '<p class="krm-kaart__t">' + esc(r.t) + '</p>' +
      '<div class="krm-kaart__f"><b>' + esc(r.n) + '</b>' +
      (r.v ? '<span class="krm-ver">Geverifieerde koper</span>' : '') +
      (r.p === undefined ? '' : '<span class="krm-kaart__p">' + (r.p ? 'Review over: ' + esc(r.p) : 'Review over Kameo als winkel') + '</span>') +
      '</div></article>';
  }
  // Lange reviews: na 7 regels afkappen met "Lees meer" (alleen waar de tekst echt overloopt).
  function kort(binnen) {
    binnen.querySelectorAll('.krm-kaart__t:not([data-krm-kort])').forEach(function (p) {
      p.setAttribute('data-krm-kort', '');
      p.classList.add('is-kort');
      if (p.scrollHeight > p.clientHeight + 2) {
        p.insertAdjacentHTML('afterend', '<button type="button" class="krm-lees" data-krm-lees>Lees meer</button>');
      } else {
        p.classList.remove('is-kort');
      }
    });
  }
  kort(sec.querySelector('.krm__grid'));

  function selectie() {
    return filter ? data.reviews.filter(function (r) { return r.s === filter; }) : data.reviews;
  }
  function render(reset) {
    var rij = selectie();
    if (reset) { lijst.innerHTML = ''; getoond = 0; dr.querySelector('.krm-dr__b').scrollTop = 0; }
    var stuk = rij.slice(getoond, getoond + PER);
    lijst.insertAdjacentHTML('beforeend', stuk.map(kaart).join(''));
    kort(lijst);
    getoond += stuk.length;
    meer.hidden = getoond >= rij.length;
    if (filter) {
      var totaal = data.verdeling[filter], metTekst = rij.length, zonder = totaal - metTekst;
      filterRegel.innerHTML = 'Reviews met ' + filter + (filter === 1 ? ' ster' : ' sterren') + ': ' + totaal +
        (zonder > 0 ? ' (' + zonder + ' zonder toelichting)' : '') + ' <button type="button" data-krm-wis>Toon alles</button>';
      filterRegel.hidden = false;
    } else {
      filterRegel.hidden = true;
    }
    sec.querySelectorAll('[data-krm-filter]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(+b.dataset.krmFilter === filter));
    });
  }
  function haal() {
    if (!laden) {
      laden = fetch(sec.dataset.krmBron).then(function (r) { return r.json(); }).then(function (j) { data = j; return j; });
    }
    return laden;
  }
  function open(metFilter) {
    vorigeFocus = document.activeElement;
    ov.hidden = false; dr.hidden = false;
    document.documentElement.classList.add('krm-slot');
    requestAnimationFrame(function () { ov.classList.add('is-open'); dr.classList.add('is-open'); });
    dr.querySelector('.krm-x').focus({ preventScroll: true });
    if (!data) lijst.innerHTML = '<p class="krm-filter">Reviews laden…</p>';
    haal().then(function () { filter = metFilter || 0; render(true); })
      .catch(function () { lijst.innerHTML = '<p class="krm-filter">Laden lukt niet. <a href="/pages/reviews">Bekijk alle reviews</a></p>'; });
  }
  function sluit() {
    ov.classList.remove('is-open'); dr.classList.remove('is-open');
    document.documentElement.classList.remove('krm-slot');
    setTimeout(function () { ov.hidden = true; dr.hidden = true; }, 300);
    filter = 0;
    sec.querySelectorAll('[data-krm-filter]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    if (vorigeFocus && vorigeFocus.focus) vorigeFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-krm-open],[data-krm-sluit],[data-krm-filter],[data-krm-wis],[data-krm-lees]');
    if (!t) return;
    if (t.hasAttribute('data-krm-lees')) {
      var p = t.previousElementSibling, open_ = p.classList.toggle('is-kort') === false;
      t.textContent = open_ ? 'Lees minder' : 'Lees meer';
      return;
    }
    if (t.hasAttribute('data-krm-open')) { e.preventDefault(); open(0); }
    else if (t.hasAttribute('data-krm-sluit')) { sluit(); }
    else if (t.hasAttribute('data-krm-wis')) { filter = 0; render(true); }
    else if (t.hasAttribute('data-krm-filter')) {
      var k = +t.dataset.krmFilter;
      if (dr.hidden) { open(k); return; }
      filter = filter === k ? 0 : k; render(true);
    }
  });
  meer.addEventListener('click', function () { render(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dr.hidden) sluit(); });
})();
